export default __webpack_public_path__ + "static/media/logo.d807ca6c.png";